import { Component, Input } from '@angular/core';
import { NETWORKING, REPORTS, TUTORIAL } from 'src/app/app-routing.module';
import { FINALRATING, PROGRESSRATING } from 'src/app/reports/reports.module';

export type BannerType =
  | 'offboarded'
  | 'offboardedCoach'
  | 'notresponsive'
  | 'tutorial'
  | 'tutorial-coach'
  | 'czMaterialsEn'
  | 'networkingRound';

@Component({
    selector: 'fp-head-banner',
    templateUrl: './head-banner.component.html',
    styleUrls: ['./head-banner.component.scss'],
    standalone: false
})
export class HeadBannerComponent {
  FINALRATING = FINALRATING;
  PROGRESSRATING = PROGRESSRATING;
  REPORTS = REPORTS;
  TUTORIAL = TUTORIAL;
  NETWORKING = NETWORKING;

  @Input() bannerType: BannerType;
}
